import React from "react";

const Subtitle = () => (
  <p className="hero__subtitle">
    Share ideas, swap insights, sharpen your thinking.
  </p>
);

export default Subtitle;
